import { REACT_APP_API_URL } from "../configs/config";

/**
 * Get latest expenses across all users (admin only)
 * @param payload - Contains page, limit, and token
 * @returns Promise with the API response
 */
const getAdminLatestExpenses = async (payload) => {
  const { page = 1, limit = 10, token } = payload;
  
  // Build query parameters
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString()
  });
  
  const response = await fetch(
    `${REACT_APP_API_URL}expenses/admin/latest?${queryParams.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

/**
 * Search expenses with advanced filters (admin only)
 * @param payload - Contains all search parameters and token
 * @returns Promise with the API response
 */
const searchExpenses = async (payload) => {
  const { 
    page = 1, 
    limit = 10, 
    userId,
    startDate, 
    endDate,
    minAmount,
    maxAmount,
    categoryId,
    paymentMethod,
    accountType,
    expenseType,
    currency,
    searchText,
    tags,
    token 
  } = payload;
  
  // Build query parameters
  const queryParams = new URLSearchParams();
  
  // Add pagination parameters
  queryParams.append('page', page.toString());
  queryParams.append('limit', limit.toString());
  
  // Add optional filters if they exist
  if (userId) queryParams.append('userId', userId);
  if (startDate) queryParams.append('startDate', startDate);
  if (endDate) queryParams.append('endDate', endDate);
  if (minAmount !== undefined) queryParams.append('minAmount', minAmount.toString());
  if (maxAmount !== undefined) queryParams.append('maxAmount', maxAmount.toString());
  if (categoryId) queryParams.append('categoryId', categoryId);
  if (paymentMethod) queryParams.append('paymentMethod', paymentMethod);
  if (accountType) queryParams.append('accountType', accountType);
  if (expenseType) queryParams.append('expenseType', expenseType);
  if (currency) queryParams.append('currency', currency);
  if (searchText) queryParams.append('searchText', searchText);
  
  // Add tags if they exist (can be multiple)
  if (tags && Array.isArray(tags)) {
    tags.forEach(tag => queryParams.append('tags', tag));
  }
  
  const response = await fetch(
    `${REACT_APP_API_URL}expenses/admin/search?${queryParams.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
  
  const responseJson = await response.json();
  return responseJson;
};

export { getAdminLatestExpenses, searchExpenses };
